// This file is generated by a script. Do not edit this file directly.
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from 'react';
export var SendFilled = function SendFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M1.742 1.351a1.25 1.25 0 0 0-1.403.29c-.36.378-.441.949-.207 1.417L3.601 10 .132 16.94A1.25 1.25 0 0 0 .34 18.36c.36.383.918.496 1.403.293l17.5-7.5c.46-.195.758-.648.758-1.148s-.297-.953-.758-1.149l-17.5-7.5z"
  }));
};
